import { MenuItem } from 'src/app/components/menu/menu-item/menu-item.interface';

export namespace MenuState {
  export const key = 'menu';

  export interface State {
    menu: MenuItem[];
  }

  export const initialState: State = {
    menu: null,
  };
}
